/* eslint-disable functional/immutable-data */

import type { Cache } from '@urql/exchange-graphcache';

import type {
  CartDataFragment,
  SubmitOrderUsingBillingAccountMutation,
  SubmitOrderUsingPaymentMethodCardMutation,
} from '@order/graphql';
import { CartDocument } from '@order/graphql';

// ────────────────────────────────────────────────────────────────────────────────

export function updateCartCache(
  cache: Cache,
  responseWithCart: MutationResponseWithCart,
) {
  if (!responseWithCart.cart) return;

  cache.updateQuery({ query: CartDocument }, (data) => {
    const shouldUpdateCache = data && responseWithCart.cart;

    if (shouldUpdateCache) data.cart = responseWithCart.cart;

    return data;
  });
}

export function invalidateCartCacheEntry(
  cache: Cache,
  response:
    | SubmitOrderUsingBillingAccountMutation['submitOrderUsingBillingAccount']
    | SubmitOrderUsingPaymentMethodCardMutation['submitOrderUsingPaymentMethodCard'],
) {
  const result = response?.__typename;

  const isBillingAccountSubmitted =
    result === 'SubmitOrderUsingBillingAccountSuccess';

  const isPaymentMethodCardSubmitted =
    result === 'SubmitOrderUsingPaymentMethodCardSuccess';

  const isSubmitted = isBillingAccountSubmitted || isPaymentMethodCardSubmitted;

  if (isSubmitted) {
    cache.updateQuery({ query: CartDocument }, (data) => {
      if (data) data.cart = null;

      return data;
    });
  }
}

// ─── TYPES ──────────────────────────────────────────────────────────────────────

export type MutationResponseWithCart = Readonly<{
  cart?: CartDataFragment;
  __typename?: string;
}>;
